import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getBanks } from 'modules/_common/api';

export const useBanksQuery = () =>
  useQuery(
    QUERY_KEYS.RENTALS_PARTNER_BANKS,
    getBanks,
    { keepPreviousData: true, staleTime: 5 * 60 * 1000 }, //5 minutes
  );
